<template lang="pug">
  .pho-multilingual-radio
    PhoRadio(
      v-model="lazyValue"
      :items="translatedItems"
      :title="title"
      :mandatory="mandatory"
      :disabled="disabled"
      :row="row"
    )
</template>
<script>
import { computed } from 'vue';
import { useContext } from '@/compat';
import { useModelAutoBinding } from '@/helpers/misc/binding';
import PhoRadio from './PhoRadio.vue';

export default {
  name: 'PhoMultilingualRadio',
  components: { PhoRadio },
  props: {
    value: {
      type: [String, Number, Boolean, Object],
      default: () => false,
    },
    items: {
      type: Array,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    mandatory: {
      type: Boolean,
      default: true,
    },
    langPath: {
      type: String,
      required: false,
      default: 'content',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { $i18n, $lang } = useContext();

    const { lazyValue } = useModelAutoBinding(emit, props);

    const translatedItems = computed(() => props.items.map(item => ({
      value: item.value,
      text: $i18n.t($lang[props.langPath][item.langKey], item.langArgs && item.langArgs.value),
      color: item.color,
    })));

    return {
      lazyValue,
      translatedItems,
    };
  },
};
</script>
